import {
	IRevConnectConfig,
	IRevConnectInfo,
	IRevConnectZoneInfo
} from './IRevConnectInfo';

import { LogLevel } from '@vbrick/vbrick-logging-client/src';

const REV_CONNECT_CONFIG_DEFAULTS: IRevConnectConfig = {
	// logging
	logLevelConsole: LogLevel.INFO,
	logLevelServer: LogLevel.DEBUG,

	// mesh join
	joinMaxTimeoutMs: 2000,
	joinNoPeersTimeoutMs: 1000,

	// media availability
	mediaAvailableDbEntryLifetimeMs: 90000,
	mediaAvailableStaggerConfig: [
		{ threshold: 15, initialPercent: 0.25 },
		{ threshold: 10, initialPercent: 0.3 },
		{ threshold: 4,	initialPercent: 0.5 },
		{ threshold: 3,	initialPercent: 0.7 },
		{ threshold: 0,	initialPercent: 1 }
	],
	mediaAvailableStaggerDelayMs: 200,
	mediaAvailableTimeoutDefaultMs: 4000,
	mediaAvailableSteadyStateDelayMs: 60000,

	// mesh query
	peerNodeQueryTimeoutMs: 300,
	pendingCheckIntervalTimeoutMs: 400,

	// mesh arbitration
	arbitrationCollisionWaitTimeMs: 150,
	arbitrationDbEntryLifetimeMs: 60000,
	notifyWaitTimeMs: 600,
	rearbitrateDelayCeilingMs: 100,

	// mesh transfer
	chunkInitialWaitDurationMultiplier: 1.2,
	chunkInitialWaitTimeoutDefaultMs: 4000,
	chunkWaitTimeoutMs: 200,
	completedOutboundTransferDbMaxLength: 100,
	fullTransferTimeoutMs: 10000,
	transferChunkMaxSize: 50000,

	// request cache
	lastHasCleanThresholdMs: 90000,

	// node connectivity
	initialPeerConnectionRetries: 1,
	initialPeerConnectionRetryIntervalMs: 1500,
	listenTimeoutMs: 5000,
	lostPeerConnectionRetries: 2,
	lostPeerConnectionRetryIntervalMs: 1000,

	stunServers: [],

	// local ip determination to bypass mdns
	ulsServerDirect: null,

	// stats collection
	enableStatsToSignaling: false,
	playlistByteEstimateMultiplier: 2.0,
	signalingByteEstimateMultiplier: 0.4,
	statsReportIntervalMs: 2500,

	// clustering
	foreignMeshConnections: 2,
	originOverlapConnectThreshold: 2,
	rebalanceThresholdDisconnectCx: 3, // if this many disconnects are needed to a foreign mesh, we will rebalance (connected node trigger)
	rebalanceThresholdDisconnectDx: 1, // if this many disconnects are needed from a foreign mesh, we will rebalance (disconnected node trigger)
	topologyQueryDelayNewMeshMs: 5000,
	topologyQueryDelayNormalMs: 2000, 
	topologyQueryDelayUrgentMs: 500

};

export class RevConnectInfoManager {
	private static revConnectInfo: IRevConnectInfo;

	public static setFullConfig(revConnectInfo: IRevConnectInfo) {
		RevConnectInfoManager.revConnectInfo = revConnectInfo;

		if (revConnectInfo) {
			const revConnectConfig: IRevConnectConfig = RevConnectInfoManager.revConnectInfo.zoneInfo.revConnectConfig;
			RevConnectInfoManager.revConnectInfo.zoneInfo.revConnectConfig = { ...REV_CONNECT_CONFIG_DEFAULTS, ...revConnectConfig };
		}
	}

	public static getFullConfig(): IRevConnectInfo {
		if (!RevConnectInfoManager.revConnectInfo) {
			throw new Error('[RevConnectInfoManager] getConfig - sequencing error, config has not been initialized');
		}

		return RevConnectInfoManager.revConnectInfo;
	}

	public static getRevConnectConfig(): IRevConnectConfig {
		return RevConnectInfoManager.getFullConfig().zoneInfo.revConnectConfig;
	}

	public static getZoneInfo(): IRevConnectZoneInfo {
		return RevConnectInfoManager.getFullConfig().zoneInfo;
	}
}
